import { roDate, type MarketProduct, t, intlLocale } from '@procumi/shared';
import { CardHead } from './shared';

/**
 * Prețurile care s-au mișcat: materialele cu cea mai mare schimbare a celui mai
 * mic preț de la ultima cerere, față de cererea trecută (minim cu minim, ca în
 * pagina Prețuri, ca cele două să arate aceleași cifre).
 */
const unit = new Intl.NumberFormat(intlLocale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function PriceMoves({
  products,
  onOpen,
  onAll,
}: {
  products: MarketProduct[];
  onOpen: (key: string) => void;
  onAll: () => void;
}) {
  const moved = products
    .filter((p) => p.change != null && Math.abs(p.change) >= 0.005)
    .sort((a, b) => Math.abs(b.change!) - Math.abs(a.change!))
    .slice(0, 5);
  const max = Math.max(...moved.map((p) => Math.abs(p.change!)), 0.01);
  return (
    <section className="db-card pm" aria-labelledby="pm-h">
      <CardHead
        id="pm-h"
        icon="tag"
        tone="night"
        title={t('Prețuri care s-au mișcat')}
        sub={t('Cel mai mic preț la ultima cerere, față de data trecută')}
        action={
          <button type="button" className="link" onClick={onAll}>
            {t('Toate prețurile')}
          </button>
        }
      />
      {moved.length ? (
        <ul className="pm-l">
          {moved.map((p) => {
            const up = p.change! > 0;
            return (
              <li key={p.key}>
                <button type="button" onClick={() => onOpen(p.key)}>
                  <span className="pm-n">
                    <b>{p.desc}</b>
                    <span>{t('acum {0} lei/{1}, la {2}', unit.format(p.now), p.unit, p.pick.name)}</span>
                  </span>
                  <span className={`pm-c ${up ? 'up' : 'down'}`}>
                    <span className="pm-bar" aria-hidden="true">
                      <span style={{ width: `${(Math.abs(p.change!) / max) * 100}%` }} />
                    </span>
                    <b>
                      {up ? '+' : '−'}
                      {Math.round(Math.abs(p.change!) * 100)}%
                    </b>
                  </span>
                  <span className="pm-best">
                    <b>
                      {p.rank.length} {p.rank.length === 1 ? t('ofertă') : t('oferte')}
                    </b>
                    <span>{roDate(p.last.at.slice(0, 10))}</span>
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      ) : (
        <p className="pm-empty">
          {t('Aici apar materialele al căror preț s-a schimbat față de data trecută când le-ai cerut.')}
        </p>
      )}
    </section>
  );
}
